<template>
  <div>
    <p class="ml-4 mb-2">{{ lang["table_manual_number"][language] }}</p>

    <div class="mx-4">
      <input
        :class="[
          'appearance-none block w-full py-3 px-4 mb-3 leading-tight focus:outline-none focus:border-primary-300 border-1.5 border-product-gray rounded-lg  transition duration-500 mb-10',
        ]"
        id="tableNumber"
        v-model="tableNumber"
        type="text"
        :style="inputBackground + inputBorder + titleMain"
        placeholder="54"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lang from "../lang";
// import { table } from "../lang";
export default {
  data() {
    return {
      lang: lang,
    };
  },
  computed: {
    ...mapGetters(["language"]),
    ...mapGetters("Cart", ["tableId", "tableManual","stickerId"]),
    ...mapGetters("Theme", ["inputBackground", "inputBorder", "titleMain"]),
    // if we already know the tableNumber we fill it in, we also keep listening to the value's. If it changes, store them in de cookies and vuexx
    tableNumber: {
      get() {
        return this.tableManual ? this.$store.getters["Cart/tableManual"] : "";
      },
      set(value) {
        if (value != "" && value != 0) {
          this.$store.commit("Cart/updateTableManual", value);
        } else {
          this.$store.commit("Cart/updateTableManual", false);
        }
        if (this.tableManual == false) {
          this.$store.commit(
            "updateIsCickable",
            "opacity-50 cursor-not-allowed"
          );
        } else {
          this.$store.commit("updateIsCickable", " ");
        }
      },
    },
  },
  methods: {
    // we can use this method if the user is connected with lightspeed
    getTable() {
      this.$store.dispatch("Cart/GET_TABLES").then((response) => {
        let tableObject = this.$_.findLast(response.data, (item) => {
          return item.stickerId == this.stickerId;
        });
        /** If valid StickerId, then update the table ID else keep it 0 (zero) */
        if (tableObject) {
          // localStorage.setItem("tableId", parseInt(tableObject.Id));
          this.$store.commit("Cart/updateTableId", parseInt(tableObject.Id));
        } else {
          this.$store.commit("Cart/updateTableId", null);
          // localStorage.setItem("tableId", null);
          this.$store.commit("Cart/updateStickerId", 0);
          // console.log("TableManual.vue Cart/updateStickerId:71", 0);
          // localStorage.setItem("stickerId", 0);
        }
      });
    },
  },
  mounted() {
    // check if you can continue to the next step or not
    if (!this.tableManual) {
      this.$store.commit("updateIsCickable", "opacity-50 cursor-not-allowed");
    } else {
      this.$store.commit("updateIsCickable", " ");
    }
  },
};
</script>

<style></style>
